export default __webpack_public_path__ + "static/media/vBeth.95b9c8af.svg";